<template>
  <div class="container">
    <div class="inner-component">
      <slot />
    </div>
    <div class="description-container" v-if="description">
      <div>
        <img src="@/assets/img/1x/0info_icon.svg" alt="info" />
      </div>
      <div>
        <span class="description" v-html="description" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "InputTip",
  props: {
    description: String
  }
};
</script>

<style scoped>
span.description {
  width: 100%;
  font-family: "BentonSansBBVA-Light", Helvetica, Arial, sans-serif;
  font-size: 12px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.33;
  letter-spacing: normal;
  color: #666666;
  white-space: normal;
}

div.description-container {
  display: flex;
  align-items: center;
  padding-top: 5px;
  padding-left: 17px;
}

div.description-container div > img {
  margin-right: 7px;
  width: 16px;
  height: 16px;
  display: block;
}

div.description-container div > span {
  display: block;
}
</style>
